<template>
  <ItemDialog ref="dialogRef" image-type="alert" :initial-open="false">
    <template #content-area>
      <h2>この予約をキャンセルしてよろしいですか？</h2>
    </template>
    <template #button-area>
      <ItemButton
        label="キャンセルする"
        action-type="btn-primary"
        @clicked="onClickCancel()"
      />
      <ItemButton
        label="戻る"
        action-type="btn-cancel"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCancelConfirm",
  props: {
    onClickCancel: {
      type: Function,
      require: true,
    },
  },
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
